import { MODAL_FOLDER_VISIBILITY } from '@components/App/Modal/constants'
import type { ID } from '@octopus-do/octopus-project-core'
import { DashboardActions } from '@store/reducers/dashboard/actions'
import { openModal } from '@storeOld/reducers/ui'
import { useDispatch } from 'react-redux'

import { OpenConfirmation } from '@/store'
import { createSwitch } from '@/utils'

const buildConfirmMessage = (title: string) =>
  `Are you sure you want to delete the folder ${title}?\n Its projects will be moved to the Archive.`

export const useFolderMenu = () => {
  const dispatch = useDispatch()

  const onClick = (
    keys: string[],
    workspaceId: ID,
    onShowRenameInput: (id: ID) => void
  ) => {
    const switcher = createSwitch()
      .case(['move_up'], (moveUpId) =>
        dispatch(
          DashboardActions.folders.move({
            direction: -1,
            workspaceId,
            id: moveUpId,
          })
        )
      )
      .case(['move_down'], (moveDownId) =>
        dispatch(
          DashboardActions.folders.move({
            direction: 1,
            workspaceId,
            id: moveDownId,
          })
        )
      )
      .case(['access'], (folderId) =>
        dispatch(
          // @ts-expect-error
          openModal(MODAL_FOLDER_VISIBILITY, { folderId })
        )
      )
      .case(['rename'], (renameId) => onShowRenameInput(renameId))
      .case(['delete_folder'], (deleteId, title) =>
        dispatch(
          OpenConfirmation({
            message: buildConfirmMessage(title),
            label: 'Delete',
            title: 'Delete folder',
            then: [
              DashboardActions.folders.delete({
                workspaceId,
                id: deleteId,
              }),
            ],
          })
        )
      )

    switcher.run(keys)
  }

  return {
    onClick,
  }
}
